import React from "react";
import PropTypes from "prop-types";

export const RoundWhatsapp = ({ color = "#FFF" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 24">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#25D366"
          fillRule="nonzero"
          d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0z"
          transform="translate(.49)"
        />
        <path
          fill={color}
          d="M16.906 7.031c.667.667 1.183 1.422 1.547 2.266.365.844.547 1.724.547 2.64 0 1.25-.318 2.407-.953 3.47-.636 1.062-1.49 1.905-2.563 2.53-1.073.625-2.234.938-3.484.938-1.188 0-2.292-.281-3.313-.844L5 19l1-3.594c-.625-1.062-.938-2.219-.938-3.469S5.375 9.531 6 8.47c.625-1.063 1.469-1.906 2.531-2.531C9.594 5.313 10.75 5 12 5c.917 0 1.797.177 2.64.531.844.354 1.6.854 2.266 1.5zM12 17.72c1.042 0 2.01-.26 2.906-.782.896-.52 1.61-1.223 2.14-2.109.532-.885.798-1.849.798-2.89 0-.75-.157-1.48-.469-2.188-.313-.708-.745-1.339-1.297-1.89-.552-.553-1.177-.975-1.875-1.266-.698-.292-1.432-.438-2.203-.438-1.042 0-2.005.26-2.89.782-.886.52-1.59 1.223-2.11 2.109-.52.885-.781 1.849-.781 2.89 0 1.105.302 2.126.906 3.063l.125.219-.594 2.125 2.188-.563.219.125c.895.542 1.874.813 2.937.813zm3.156-4.344l.094.063c.146.062.23.114.25.156.02.041.026.146.016.312-.01.167-.052.339-.125.516-.073.177-.24.354-.5.531-.26.177-.485.276-.672.297-.292.042-.573.042-.844 0-.313-.063-.73-.208-1.25-.438-1.063-.458-2.031-1.312-2.906-2.562l-.063-.063c-.458-.645-.687-1.24-.687-1.78 0-.542.187-1.011.562-1.407l.031-.031c.146-.146.303-.219.47-.219h.374c.084 0 .151.016.203.047.052.031.1.11.141.234l.531 1.281c.063.126.073.23.031.313-.104.208-.24.396-.406.563-.083.083-.135.15-.156.203-.02.052 0 .109.063.171.291.542.635.97 1.03 1.282.292.229.73.49 1.313.781.167.083.292.073.375-.031.271-.313.459-.542.563-.688.041-.083.094-.125.156-.125.063 0 .135.01.219.031.166.063.562.25 1.187.563z"
          transform="translate(.49)"
        />
      </g>
    </svg>
  );
};
RoundWhatsapp.propTypes = {
  color: PropTypes.string
};
